import src from '../assets/draperindoorgolf-dark.png';
import { imageLogo } from './imageLogo';

/**
 * Draper Indoor Golf — dark-surface badge: green golf-clock icon on a solid
 * black plate. For use on the branded canvas only — the black plate blends
 * with the dark ground, so no rounding or further treatment is needed.
 */
export const DraperIndoorGolfDarkLogo = imageLogo({
  src,
  width: 2732,
  height: 2732,
  alt: 'Draper Indoor Golf',
});
